module.exports = "../../app/cells/pages/question/next_question_cell.rb";